import { css } from '@emotion/core';
import styled from '@emotion/styled';

// Consumer will likely want to choose a height, padding, and border customizations for themselves

export default styled.div`
  width: 100%;
  height: 100%;
  display: inline-flex;
  border: 1px solid var(--color-border-medium);
  background-color: var(--color-background-white);
  ${({ focused }) =>
    focused &&
    css`
      border-color: var(--color-button-secondary-hover);
    `}
  ${({ disabled }) =>
    !disabled &&
    css`
      &:hover {
        border-color: var(--color-button-secondary-hover);
      }
    `}

  ${({ readOnly }) =>
    readOnly &&
    css`
      input {
        cursor: default !important;
      }

      border-color: var(--color-border-medium) !important;
    `}

  ${({ error }) =>
    error &&
    css`
      &&,
      &&:hover {
        // Ensure to trump disabled hover state
        border-color: var(--color-button-warning-hover);
      }
    `}
  ${({ disabled, overrideDisabledColor = false }) =>
    disabled &&
    !overrideDisabledColor &&
    css`
      background-color: var(--color-background-lightest);

      &:hover {
        // Explicitness here helps combat default styles from elsewhere e.g. react-select
        border-color: var(--color-border-medium);
      }
    `}
`;
